import React from "react";

// components
import Item from "./Item";

// styles
import styles from "./styles.module.scss";

const Trending = () => {
  return (
    <div className={styles.trending__wrapper}>
      <h1>1 Trending Events</h1>
      <div className={styles.trending__list}>
        <Item />
        <Item />
      </div>
    </div>
  );
};

export default Trending;
